/*
  Contact switchboard.

  Progressive by construction: the markup ships with every field visible and a
  working Shopify contact form. This narrows it. If the file fails to load the
  page is a longer form, not a broken one.
*/
(function () {
  'use strict';

  var desk = document.querySelector('.fl-desk');
  if (!desk) return;

  var doors = Array.prototype.slice.call(desk.querySelectorAll('[data-fl-door]'));
  var subjectField = desk.querySelector('[data-fl-subject-field]');
  var conditional = Array.prototype.slice.call(desk.querySelectorAll('[data-fl-for]'));
  if (!doors.length) return;

  function select(key, focusForm) {
    doors.forEach(function (d) {
      d.setAttribute('aria-pressed', String(d.dataset.flDoor === key));
    });

    conditional.forEach(function (row) {
      var shown = row.dataset.flFor.split(/\s+/).indexOf(key) !== -1;
      row.hidden = !shown;
      // A hidden field must not submit a stale value from a previous choice.
      row.querySelectorAll('input, select, textarea').forEach(function (f) {
        f.disabled = !shown;
      });
    });

    var chosen = doors.filter(function (d) { return d.dataset.flDoor === key; })[0];
    if (subjectField && chosen) subjectField.value = chosen.dataset.flSubject || '';

    if (focusForm) {
      var first = desk.querySelector('.fl-desk__row:not([hidden]) .fl-desk__input');
      if (first) first.focus({ preventScroll: true });
    }
  }

  doors.forEach(function (d) {
    d.addEventListener('click', function () {
      select(d.dataset.flDoor, true);
    });
  });

  // ?subject=wholesale deep-links a route, so the private-label page and the
  // footer can point straight at the right door.
  var wanted = new URLSearchParams(window.location.search).get('subject');
  var known = doors.map(function (d) { return d.dataset.flDoor; });
  select(known.indexOf(wanted) !== -1 ? wanted : known[0], false);
})();
